module.exports = __webpack_public_path__ + "static/img/up-gray.0b22795d.svg";